import ChangeOptionDialog from "../change-option-dialog/ChangeOptionDialog";
import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import GenericDialog from "../../../../../../../../../../ui/dialogs/generic-dialog/GenericDialog";
import Typography from "@material-ui/core/Typography";
import {useDispatch, useSelector} from "react-redux";
import {fetchSimsNotAssociatedToOption} from "../../../../../../../../../../../store/contratto-digitale/actions";
import AssociateRemoveSimServerSideModal
    from "../../../../../../../../soglie-eventi/soglie/associate-remove-sim-server-side-modal/AssociateRemoveSimServerSideModal";
import {
    filterInitialState,
    sortingCriteria
} from "../../../../../../../../soglie-eventi/soglie/associate-remove-sim-server-side-modal/AssociateRemoveSimServerSideModalHelper";
import {shouldDisableDispositiveActions} from "../../../../../../../../sim/SimHelper";

const AggiuntaSimOptionDialog = (props) => {
    const [openChangeOptionDialog, setOpenChangeOptionDialog] = useState(false)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(5)
    const [areAllSelected, setAreAllSelected] = useState(false)
    const [sorting, setSorting] = useState(`${sortingCriteria[0].value},desc`)
    const [currentFilterHistory, setCurrentFilterHistory] = useState(filterInitialState)
    const [selectedSims, setSelectedSims] = useState([])
    const typeUser = useSelector(state => state.authReducer.userClaims.typeUser)
    const roles = useSelector(state => state.authReducer.userClaims.roles)
    const notAssociatedSimsToOption = useSelector((state) => state.contrattoDigitaleReducer.simsNotAssociatedToOption)
    const dispatch = useDispatch()
    const handleConfirmClick = () => {
        setOpenChangeOptionDialog(true)
    }

    useEffect(() => {
        dispatch(fetchSimsNotAssociatedToOption(props.option.commercialLabel, page, rowsPerPage, sorting, currentFilterHistory))
    }, [dispatch, props.option.commercialLabel, page, rowsPerPage, sorting, currentFilterHistory])

    const disableDispositiveActions = shouldDisableDispositiveActions(typeUser, roles) ||
        selectedSims.filter(sim => sim.wrenchDto.showWrench).length > 0

    const dialogContent = (
        <AssociateRemoveSimServerSideModal
            disableConfirmBtn={disableDispositiveActions}
            buttonLoading={false}
            sorting={sorting}
            setSorting={setSorting}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            page={page}
            setPage={setPage}
            currentFilterHistory={currentFilterHistory}
            setCurrentFilterHistory={setCurrentFilterHistory}
            areAllSelected={areAllSelected}
            setAreAllSelected={setAreAllSelected}
            selectedSims={selectedSims}
            setSelectedSims={setSelectedSims}
            handleConfirmClick={handleConfirmClick}
            tableData={notAssociatedSimsToOption.data.data}
            loading={notAssociatedSimsToOption.loading}
            showFiltriButton={true}
            isFromContratto
            isOption
            count={notAssociatedSimsToOption.data.totalItems}
            description={"Verranno mostrato solo le sim compatibili con quest'offerta"}/>
    )

    return (
        <GenericDialog open={props.open}
                       handleDialogClose={props.handleDialogClose}
                       handleDialogCloseButton={props.handleDialogClose}
                       dialogContent={dialogContent}
                       dialogWidth={"md"}
                       error={notAssociatedSimsToOption.error}>
            <Typography variant={"h6"}>
                Aggiunta SIM
            </Typography>
            {openChangeOptionDialog ? <ChangeOptionDialog open={openChangeOptionDialog}
                                                          handleDialogClose={() => setOpenChangeOptionDialog(false)}
                                                          isRemove={false}
                                                          option={props.option}
                                                          selectedSims={selectedSims}/> : null}
        </GenericDialog>
    )
}

ChangeOptionDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
    option: PropTypes.object.isRequired,
}

export default AggiuntaSimOptionDialog